<template>
  <v-flex
    id="locationData"
    class="question"
  >
    <h2 class="header">
      {{ $t('warehouses.locationData.title') }}
    </h2>
    <ul class="questions-list">
      <li class="mt-4">
        <p class="header required mb-0">
          {{ $t('warehouses.locationData.warehouse_name') }}
        </p>
        <v-flex
          xs12
          sm6
        >
          <v-text-field
            v-model="warehouseName"
            v-validate="validationRules.get('warehouseName')"
            :placeholder="$t('warehouses.locationData.warehouse_name')"
            :error-messages="errors.collect('warehouseName')"
            :data-vv-as="' '"
            :data-vv-name="'warehouseName'"
            required
            auto-grow
          />
        </v-flex>
        <small class="font-italic font-weight-regular">{{ $t('warehouses.locationData.warehouse_name_hint') }}</small>
      </li>
    </ul>
    <warehouseAddress
      :warehouse-type="2"
      @emitAddress="getAddress($event)"
    />
    <openingHours
      :warehouse-type="2"
      @emitHours="getHours($event)"
    />
    <roadDirections
      :warehouse-type="2"
      @emitDirections="getDirections($event)"
    />
    <v-divider class="my-4" />
  </v-flex>
</template>

<script>
import validationRules from '@/constants/validationRules';
import warehouseAddress from '@/components/widgets/warehouse/locationData/warehouseAddress';
import openingHours from '@/components/widgets/warehouse/locationData/openingHours';
import roadDirections from '@/components/widgets/warehouse/locationData/roadDirections';

import { createHelpers } from 'vuex-map-fields';

const { mapFields: mapNameField } = createHelpers({
    getterType: 'warehouses/getSupportingWarehouseNameField',
    mutationType: 'warehouses/updateSupportingWarehouseNameField'
});

const { mapFields: mapAddressField } = createHelpers({
    getterType: 'warehouses/getSupportingWarehouseAddressFields',
    mutationType: 'warehouses/updateSupportingWarehouseAddressFields'
});

const { mapFields: mapHoursField } = createHelpers({
    getterType: 'warehouses/getSupportingWarehouseOpeningFields',
    mutationType: 'warehouses/updateSupportingWarehouseOpeningFields'
});

export default {
    name: 'SupportingLocationData',
    components: {
        warehouseAddress,
        openingHours,
        roadDirections
    },
    inject: ['$validator'],
    data () {
        return {
            validationRules
        };
    },
    computed: {
        ...mapNameField(['warehouseName', 'directions']),
        ...mapAddressField([
            'locationName',
            'street',
            'city',
            'flatNumber',
            'placeNumber',
            'province',
            'postalCode'
        ]),
        ...mapHoursField(['firstDayFrom', 'firstDayTo', 'secondDayFrom', 'secondDayTo'])
    },
    methods: {
        getAddress (event) {
            this.locationName = event.locationName;
            this.street = event.street;
            this.city = event.city;
            this.flatNumber = event.flatNumber;
            this.placeNumber = event.placeNumber;
            this.province = event.province;
            this.postalCode = event.postalCode;
        },
        getHours (event) {
            this.firstDayFrom = event.firstDayFrom;
            this.firstDayTo = event.firstDayTo;
            this.secondDayFrom = event.secondDayFrom;
            this.secondDayTo = event.secondDayTo;
        },
        getDirections (event) {
            this.directions = event;
        }
    }
};
</script>

<style scoped></style>
